module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clum2right left"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_block"
    }
  }, [_c('div', {
    staticClass: "account_icon left"
  }), _vm._v(" "), (_vm.isReadOnly) ? _c('div', {
    staticClass: "content_title left"
  }, [_vm._v("My Profile")]) : _c('div', {
    staticClass: "content_title left"
  }, [_vm._v("My Profile > Edit")]), _vm._v(" "), _c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_main"
    }
  }, [_c('div', {
    staticClass: "pure-form pure-form-aligned"
  }, [_c('fieldset', [_c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strEmail),
      expression: "strEmail"
    }],
    class: {
      'pure-input-2-3': true, inputread: _vm.isReadOnly
    },
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "username@domain.com",
      "readonly": _vm.isReadOnly,
      "disabled": !_vm.isReadOnly
    },
    domProps: {
      "value": (_vm.strEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.strEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strFirstName),
      expression: "strFirstName"
    }],
    class: {
      'pure-input-2-3': true, inputread: _vm.isReadOnly
    },
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "First Name",
      "readonly": _vm.isReadOnly
    },
    domProps: {
      "value": (_vm.strFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.strFirstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strLastName),
      expression: "strLastName"
    }],
    class: {
      'pure-input-2-3': true, inputread: _vm.isReadOnly
    },
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Last Name",
      "readonly": _vm.isReadOnly
    },
    domProps: {
      "value": (_vm.strLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.strLastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Telephone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    class: {
      'pure-input-2-3': true, inputread: _vm.isReadOnly
    },
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "+886-3-5525279",
      "readonly": _vm.isReadOnly
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-controls",
    staticStyle: {
      "margin-left": "170px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReadOnly),
      expression: "isReadOnly"
    }],
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.edit()
      }
    }
  }, [_vm._v("Edit Profile")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReadOnly),
      expression: "isReadOnly"
    }],
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.changepsw()
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "reset",
      "value": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.modifyaccount()
      }
    }
  }, [_vm._v("Save")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28a393e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/pages/ProfileDetail.vue
// module id = 104
// module chunks = 1